import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {FusePageSimple, FuseAnimate} from '@fuse';
import {Avatar, Tab, Tabs, Typography} from '@material-ui/core';
import AboutTab from './tabs/AboutTab';
import {connect} from "react-redux";
import {UecareUploadAvatar} from "../../../components";
import {bindActionCreators} from "redux";
import ReduxCallHelper from "../../../store/actionreducers/callHelper";
import ChangePassword from "../../../components/ChangePassword";

class ProfilePage extends Component {

    state = {
        value: 0
    };

    handleChange = (event, value) => {
        this.setState({value});
    };

    async updateUserAvatar(base64Image) {
        await this.props.updateUserAvatar({userId: this.props.user.id, base64_src: base64Image})
    }

    render() {
        const {classes, user} = this.props;
        const {value} = this.state;

        return (
            <FusePageSimple
                classes={{
                    root: classes.layoutRoot,
                    header: classes.layoutHeader,
                    toolbar: classes.layoutToolbar
                }}
                header={
                    <div className="p-24 flex flex-1 flex-col items-center justify-center md:flex-row md:items-end">
                        <div
                            className="flex flex-1 flex-col items-center justify-center md:flex-row md:items-center md:justify-start">
                            <FuseAnimate animation="transition.expandIn" delay={300}>
                                {user.data.photoURL ?
                                    (<UecareUploadAvatar src={user.data.photoURL} className="w-96 h-96"
                                                         saveNewImage={this.updateUserAvatar.bind(this)}/>)
                                    : (<Avatar className="w-96 h-96">
                                        <Typography variant="display3"
                                                    color="default">{user.data.displayName[0]}</Typography>
                                    </Avatar>)
                                }
                            </FuseAnimate>
                            <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                <Typography className="md:ml-24" variant="display1" color="inherit">
                                    {user.data.displayName}
                                </Typography>
                            </FuseAnimate>
                        </div>
                    </div>
                }
                contentToolbar={
                    <Tabs
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        scrollable
                        scrollButtons="auto"
                        classes={{
                            root: classes.tabsRoot
                        }}
                    >
                        <Tab
                            className="font-bold"
                            classes={{ root: classes.tabRoot }}
                            label="關於我"/>
                        <Tab
                            className="font-bold"
                            classes={{ root: classes.tabRoot }}
                            label="修改密碼"/>

                    </Tabs>
                }
                content={
                    <div className="p-24">
                        {value === 0 && <AboutTab />}
                        {value === 1 && <ChangePassword /> }
                    </div>
                }
            />
        )
    };
}

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    layoutHeader: {
        height: 320,
        minHeight: 320,
        background: "url('/assets/images/backgrounds/dark-material-bg.jpg') no-repeat",
        backgroundSize: 'cover',
        color: '#fff',
        [theme.breakpoints.down('md')]: {
            height: 240,
            minHeight: 240
        }
    },
    tabsRoot: {
        height: 64,
        width: '100%'
    },
    tabRoot: {
        height: 64
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateUserAvatar: ReduxCallHelper.ActionCreator.updateUserAvatar,
    }, dispatch);
}

function mapStateToProps({auth}) {
    return {
        user: auth.user
    }
}

export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(ProfilePage));



// WEBPACK FOOTER //
// ./src/main/content/profile/ProfilePage.js